module.exports = __webpack_public_path__ + "img/img_24h@2x.7b1e36dd.png";